import { makeStyles } from '@mui/styles';
import FormHelperText from 'apollo-react/components/FormHelperText';
import React from 'react';

const useStyles = makeStyles({
  formHelperTextStyled: {
    transform: 'none',
    position: 'relative',
    alignSelf: 'flex-start',
    fontSize: '1rem',
    marginBottom: '0.5rem',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.62,
    letterSpacing: 'normal',
    color: '#444444 !important',
    fontFamily: 'sans-serif',
  },
  error: {
    color: '#F44336 !important',
  },
});

const FormHelperTextStyled = (props) => {
  const classes = useStyles();

  const { error } = props;
  return (
    <FormHelperText
      className={[classes.formHelperTextStyled, error ? classes.error : '']}
      {...props}
    />
  );
};

export default FormHelperTextStyled;
